module.exports = __webpack_public_path__ + "img/vegetable-zucchini-350x184.be34cbb6.jpg";